import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=f42a5562&scoped=true"
import script from "./SysConfig.vue?vue&type=script&lang=js"
export * from "./SysConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42a5562",
  null
  
)

export default component.exports